/* eslint-disable @typescript-eslint/ban-ts-comment */
import { proStudioUrqlGql as urqlGql } from '@pypestream/api-services';
import { throwErrorWithId } from '@pypestream/utils';

import { ProStudioContext, ProStudioEvents } from '../prostudio.xstate.types';

export const deleteAsset = async (
  ctx: ProStudioContext,
  event: ProStudioEvents
): Promise<{ selectedBot: ProStudioContext['selectedBot'] } | void> => {
  if (event.type !== 'deleteAsset') {
    return;
  }

  const { botName, customerId, selectedBot, project } = ctx;

  const projectId = project?.id;

  if (!projectId) {
    throwErrorWithId('Project ID is required');
    return;
  }

  if (!customerId) {
    throwErrorWithId('Customer ID is required');
  }

  if (!botName) {
    throwErrorWithId('Bot Name is required');
  }

  const botId = `${customerId}.${botName}`;

  if (!selectedBot) {
    throwErrorWithId('Selected bot is required');
  }

  await urqlGql.deleteBotAsset({
    assetId: encodeURIComponent(event.id),
    botId,
    projectId,
  });

  return {
    selectedBot: {
      ...ctx.selectedBot,
      assets:
        (ctx.selectedBot?.assets as { id: string; url: string }[])?.filter(
          ({ id }) => id !== event.id
        ) || [],
    },
  };
};
